import * as R from 'ramda';
import { createSelector } from 'reselect';
// helpers/constants
import * as G from '../../helpers';
// report-common
import { getReportSelectors } from '../../report-common';
//////////////////////////////////////////////////

const {
  store,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectUsedReport,
  makeSelectListLoading,
  makeSelectPageVisited,
  makeSelectReportStatus,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
} = getReportSelectors('quotes');

const makeSelectQuotesList = () => createSelector(
  store,
  ({ itemList }) => R.sortBy(R.prop('index'), R.values(itemList)),
);

const makeSelectRouteTab = () => createSelector(
  store,
  ({ routeTab }) => routeTab,
);

const makeSelectListType = () => createSelector(
  store,
  ({ listType }) => listType,
);

const makeSelectSelectedList = () => createSelector(
  store,
  R.compose(
    R.values,
    R.map(G.getGuidFromObject),
    R.filter(({ selected }) => selected),
    R.pathOr([], ['itemList']),
  ),
);

export {
  makeSelectRouteTab,
  makeSelectListType,
  makeSelectQuotesList,
  makeSelectTotalCount,
  makeSelectPagination,
  makeSelectUsedReport,
  makeSelectPageVisited,
  makeSelectListLoading,
  makeSelectSelectedList,
  makeSelectReportStatus,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
};
